import { defineStore } from 'pinia'

export const useAccountOpeningStore = defineStore('accountOpening', {
  state: () => ({
    accountType: '',
    preAccountType: '',
    currencyType: '',
    activeAccountTypes: [],
    signature: null,
    documentOption: '',
    currentFlow: '', // 'omni' | 'acc' | ''
  }),
  getters: {
    hasSignature: (state) => !!state.signature,
  },
  actions: {
    setAccountType(accountType) {
      this.accountType = accountType
    },
    setPreAccountType(preAccountType) {
      this.preAccountType = preAccountType
    },
    setCurrencyType(currencyType) {
      this.currencyType = currencyType
    },
    setActiveAccountTypes(activeAccountTypes) {
      this.activeAccountTypes = activeAccountTypes
    },
    setSignature(signature) {
      this.signature = signature
    },
    setDocumentOption(documentOption) {
      this.documentOption = documentOption
    },
    setCurrentFlow(flow) {
      this.currentFlow = flow
    },
    selectAccountAndCurrency({ accountType, preAccountType, currencyType }) {
      if (accountType) this.accountType = accountType
      if (preAccountType) this.preAccountType = preAccountType
      if (currencyType) this.currencyType = currencyType
    },
    clearAccountOpening() {
      this.$reset()
    },
  },
  persist: true,
})
